module.exports = __webpack_public_path__ + "img/mng.e28b251c.png";